var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5482 12.9624C10.5485 13.6785 9.32349 14.1 8 14.1C4.63106 14.1 1.9 11.3689 1.9 8C1.9 6.67651 2.32149 5.45147 3.03756 4.45177L11.5482 12.9624ZM12.9624 11.5482L4.45177 3.03756C5.45147 2.32149 6.67651 1.9 8 1.9C11.3689 1.9 14.1 4.63106 14.1 8C14.1 9.32349 13.6785 10.5485 12.9624 11.5482ZM16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
    fill: "#DD4C1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.73233a82e91a541fdb80f27a466d3c4b.svg";
export { ForwardRef as ReactComponent };